import { IEntitlement } from "../interfaces/session/entitlement.interface";
import * as Entitlements from "../constants/entitlements";
import { getSessionData } from "./user-session";

const getEntitlement = (entitlementName: string): IEntitlement | undefined => {
  const data = getSessionData();
  if (!data) {
    return;
  }

  const entitlements: IEntitlement[] = data.entitlements;
  if (!entitlements || entitlements.length === 0) {
    return;
  }

  return entitlements.find((e: IEntitlement) => e.entitlementName === entitlementName);
};

const validateWriteEntitlement = (entitlementName: string): boolean => {
  const entitlement: IEntitlement | undefined = getEntitlement(entitlementName);
  if (!entitlement) {
    return false;
  }

  return entitlement.write === 1;
};

const validateReadEntitlement = (entitlementName: string): boolean => {
  const entitlement: IEntitlement | undefined = getEntitlement(entitlementName);
  if (!entitlement) {
    return false;
  }

  return entitlement.read === 1;
};

export const hasPlaceOrderItemAccess = () => {
  if (validateWriteEntitlement(Entitlements.ORDERS)) {
    return true;
  }
  if (validateWriteEntitlement(Entitlements.ORDER_ITEMS_PLACE)) {
    return true;
  }
  return false;
};

export const hasCancelOrderItemAccess = () => {
  if (validateWriteEntitlement(Entitlements.ORDERS)) {
    return true;
  }
  if (validateWriteEntitlement(Entitlements.ORDER_ITEMS_CANCEL)) {
    return true;
  }
  return false;
};

export const hasUpdateOrderItemAccess = () => {
  if (validateWriteEntitlement(Entitlements.ORDERS)) {
    return true;
  }
  return false;
};

export const hasPlaceOrderRetryAccess = () => {
  if (validateWriteEntitlement(Entitlements.ORDERS)) {
    return true;
  }
  return false;
};

export const hasReportOrderSummaryAccess = () => {
  if (validateReadEntitlement(Entitlements.REPORTS_ORDERS_SUMMARY)) {
    return true;
  }
  return false;
};

export const hasReportOrderItemsAccess = () => {
  if (validateReadEntitlement(Entitlements.REPORTS_ORDERS_ITEMS)) {
    return true;
  }
  return false;
};
